import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { Observable, map } from 'rxjs';
import { PhysicianService } from '../services/physician.service';

export class PhysicianValidator {
  static createValidator(service: PhysicianService): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors> => {
      return service
        .physicianExists(control.value)
        .pipe(map((result: boolean) => (result ? null : { physicianNotExist: true })));
    };
  }
}
